import { AspectRatio } from '@chakra-ui/react'

interface IBlogEmbeddedVideo {
  embedUrl: string
}

const BlogEmbeddedVideo = ({ embedUrl }: IBlogEmbeddedVideo) => {
  return (
    <AspectRatio ratio={16 / 9} width="full" height="full">
      <iframe
        title="3D Tour Video | SSM"
        src={embedUrl}
        allowFullScreen
        frameBorder="0"
      />
    </AspectRatio>
  )
}

export default BlogEmbeddedVideo
